<template>
  <content-view>
    <div class="outbound">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="选择商品仓库：" :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
          <a-select
            v-decorator="['storeageId', {rules: [{ required: true, message: '请选择商品仓库'}]}]"
            placeholder="请选择"
            @change="changeStore"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in wareHouseList"
              :key="index"
            >{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="出库商品名称、数量："
          :label-col="{ span: 6, }"
          :wrapper-col="{ span: 6 }"
          v-for="(item, index) in addTrade"
          :key="index"
        >
          <a-select
            showSearch
            v-decorator="['tradeName' + item.index, {rules: [{ required: true, message: '请选择调拨商品'}]}]"
            placeholder="请选择"
            @change="changeGoods"
            @search="searchGoods"
            :defaultActiveFirstOption="false"
            :showArrow="false"
            :filterOption="false"
            :notFoundContent="null"
          >
            <a-select-option
              v-for="(item1) in item.options"
              :key="item1.id"
              :value="item1.id+'?='+item1.num+'?='+index"
            >{{item1.name}}（库存量{{item1.num}}）</a-select-option>
          </a-select>
          <a-input-number
            :max="item.num"
            :min="0"
            placeholder="请输入数量"
            class="enterNumber ant-col-6"
            v-model="tradeNumber[index]"
          />
          <div class="extra_action">
            <a href="javascript:;" v-if="index == 0" @click="addNewTrade">继续添加商品</a>
            <a-divider type="vertical" v-if="index == 0"/>
            <a href="javascript:;" @click="delectTrade(index)">删除</a>
          </div>
        </a-form-item>
        <a-form-item label="出库原因：" :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
          <a-radio-group v-decorator="['outType',{initialValue: 1}]">
            <a-radio :value="1">售卖</a-radio>
            <a-radio :value="2">自用</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="申请原因：" :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
          <a-textarea placeholder="请输入"
            v-decorator="['reason',{rules: [{ required: true, message: '请输入申请原因'}]}]"
            :autosize="{ minRows: 2, maxRows: 12 }"/>
        </a-form-item>
        <a-form-item
          label="审核人职位："
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 13 }"
        >
          <a-select
            v-decorator="['approvalRoleId',{rules: [{ required: true, message: '请选择审核人职位'}]}]"
            placeholder="请选择"
            @change="changeApprovalRole"
          >
            <a-select-option
              :value="item.id"
              v-for="item in comfirmRoleList"
              :key="item.id"
            >{{item.roleName}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="审核人："
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 13 }"
        >
          <a-select
            v-decorator="['approvalUserId',{rules: [{ required: true, message: '请选择审核人'}]}]"
            placeholder="请选择"
          >
            <a-select-option
              :value="item.id"
              v-for="item in comfirmMemberList1"
              :key="item.id"
            >{{item.username}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="text-center">
          <a-button @click="$router.go(-1)">取消</a-button>
          <a-button type="primary" html-type="submit">发起审核</a-button>
        </a-form-item>
      </a-form>
    </div>
  </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    export default {
        name: 'outbound',
        components: {},
        props: {},
        data() {
            return {
                addTrade: [
                    {
                        index: 1,
                        options: [],
                        num: 1
                    }
                ],
                form: this.$form.createForm(this),
                tradeNumber: [],
                comfirmRoleList: [],
                comfirmMemberList: [],
                comfirmMemberList1: [],
                wareHouseList: [],
                goodsLists: [],
                warehouseId: ''
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            handleSubmit(e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                        var list = {
                            approvalRoleId: values.approvalRoleId,
                            approvalUserId: values.approvalUserId,
                            outType: values.outType,
                            storeageId: values.storeageId,
                            reason: values.reason,
                            goodsList: [],
                        };
                        values.tradeNumber = this.tradeNumber;
                        for (let i = 0; i < this.tradeNumber.length; i++) {
                            if(!this.tradeNumber[i]) {
                                this.$message.error('请输入出库数量')
                                return false
                            }
                            if(values[`tradeName${i + 1}`] === values[`tradeName${i}`]) {
                                this.$message.error('出库商品不能重复，请重新选择')
                                return false
                            }
                            list.goodsList.push({
                                id: values[`tradeName${i + 1}`].split('?=')[0],
                                num: this.tradeNumber[i],
                                currentInventory: Number(values[`tradeName${i + 1}`].split('?=')[1]),
                            });
                        }
                        this.goodsOut(list);
                    }
                });
            },
            searchGoods(goodsName) {
                if (!this.warehouseId) {
                    this.$message.warning('请选择仓库');
                    return false;
                }
                if (!goodsName) {
                  this.addTrade = [
                    {
                        index: 1,
                        options: [],
                        num: 1
                    }
                  ]
                  return;
                }
                this.$api.storage
                    .SearchWareGoodsList({
                        body: {
                            goodsName: goodsName,
                            pageNum: 1,
                            pageSize: 9999,
                            shopId: this.$store.getters.shopId,
                            useType: this.useType,
                            warehouseId: this.warehouseId
                        }
                    })
                    .then(res => {
                        this.goodsLists = res;
                        for (let i in this.addTrade) {
                            this.addTrade[i].options = res;
                        }
                    });
            },
            //添加新商品
            addNewTrade() {
                this.addTrade.push({
                    index: this.addTrade[this.addTrade.length - 1].index + 1,
                    options: this.goodsLists,
                    num: 1
                });
            },
            // 删除商品
            delectTrade(index) {
                this.addTrade.splice(index, 1);
            },
            // 发起审核
            goodsOut(params) {
                this.$api.storage.goodsOut({ body: params }).then(res => {
                    this.$message.success(
                        '已成功发起审核，可在审核管理中查看审核状态'
                    );
                    this.$router.go(-1)
                });
            },
            //审核人职位
            comfirmRole() {
                this.$api.storage.comfirmRole({
                  params: {shopId: this.shopId}
                }).then(res => {
                    this.comfirmRoleList = res;
                    this.comfirmMember();
                });
            },
            //审核人
            comfirmMember() {
                if(!this.shopId) return
                this.$api.storage.comfirmMember({params: {
                  shopId: this.shopId
                }}).then(res => {
                    this.comfirmMemberList = res;
                });
            },
            changeApprovalRole(e) {
                this.form.resetFields(["approvalUserId"]);
                this.comfirmMemberList1 = this.comfirmMemberList.filter(el => {
                    return el.roleId == e;
                });
            },
            // 获取所有仓库
            getWarehouseList() {
                if(!this.shopId) return
                this.$api.storage.getWarehouseList({params: {
                    shopId: this.shopId
                }}).then(res => {
                    this.wareHouseList = res;
                });
            },
            // 切换仓库时改变该仓库里的商品
            changeStore(e) {
              this.warehouseId = e;
                // useType = 0 默认搜该仓库下的所有商品
                // this.$api.storage.wareGoodsList({
                //     params: {warehouseId: e,useType: 0}
                // }).then(res => {
                //     this.goodsLists = res;
                //     for (let i in this.addTrade) {
                //         this.addTrade[i].options = res;
                //     }
                // });
            },
            // 切换出库商品时 拿到该商品的可出库最大值
            changeGoods(e) {
                this.addTrade[Number(e.split('?=')[2])].num = Number(e.split('?=')[1])
            }
        },
        created() {},
        mounted() {
            this.getWarehouseList();
            this.comfirmRole();
        },
        watch: {
            'shopId'() {
                this.form.setFieldsValue({['storeageId']: '',['approvalUserId']: ''})
                this.getWarehouseList()
                this.comfirmMember();
            }
        }
    };
</script>
<style lang="scss">
  .outbound {
      background-color: #fff;
      padding: 24px 32px;
      border-radius: 2px;
      .extra_action {
          position: absolute;
          left: 220%;
          top: 0;
          width: 280px;
          a {
              color: #f57f25;
              font-size: 14px;
              text-decoration: #f57f25;
          }
      }
  }
  .auditInfo {
      display: flex;
      flex-direction: column;
      align-items: center;
      button {
          margin-top: 20px;
      }
  }
  .enterNumber {
      width: 100%;
      position: absolute;
      margin-left: 40px;
  }
</style>